import React, { useState, memo, useEffect, Fragment } from "react";

import { AvailableAcceptanceResult } from './AvailableAcceptanceResult';

export const AvailableForm = (props) => {
  const { init_hospital, corporations } = props;

  return (
    <>
      <div className="accordion-item mt-5">
        <h2 className="accordion-header" id="panelsStayOpen-headingAvailable">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseAvailable" aria-expanded="true" aria-controls="panelsStayOpen-collapseAvailable">
            [実績]受入有りの一覧企業
          </button>
        </h2>
        <div id="panelsStayOpen-collapseAvailable" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingAvailable">
          <div className="accordion-body">
            <AvailableAcceptanceResult init_hospital={init_hospital} corporations={corporations} />
          </div>
        </div>
      </div>
    </>
  );
};